export const ITEM_TYPE = {
  link: 'link',
  menu: 'menu',
  collapse: 'collapse',
  header: 'header',
  intelligenceChannel: 'intelligenceChannel',
  brandVoice: 'brandVoice',
  visualLanguage: 'visualLanguage',
};

export const isSubmenuItemType = (type) =>
  [ITEM_TYPE.intelligenceChannel, ITEM_TYPE.brandVoice, ITEM_TYPE.visualLanguage].includes(type);

export const SIDEBAR_ACTION = {
  createBrandVoice: 'createBrandVoice',
  editBrandVoice: 'editBrandVoice',
  deleteBrandVoice: 'deleteBrandVoice',

  createVisualLanguage: 'createVisualLanguage',
  editVisualLanguage: 'editVisualLanguage',
  deleteVisualLanguage: 'deleteVisualLanguage',
};
